const PageNotFound = () => {
  return (
    <div className="flex flex-col justify-center min-h-screen text-4xl md:text-9xl">
      <p className="text-center">404 Page Not Found</p>
    </div>
  );
};

export default PageNotFound;
